<template>
     <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header" style="padding-top:30px;padding-bottom:50px;">
              <h3>Your Exam Result</h3>
              <table>
                <tr>
                    
                    <td>Total Mark</td><td>{{ result.total_mark }}</td>
                </tr>
              </table>
              <p class="red-text">You can also view your mark in your exam page</p>
             
          </div>
          <div class="modal-footer">
                <button class="btn" @click="$emit('finish')">Finish</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
    computed: {
        result()
        {
            return this.$store.getters.exam_result;
        }
    },
}
</script>
<style lang="scss">
    @import "@/style/colors.scss";
    
    .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    }

    .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    }

    .modal-container {
    width: 500px;
    
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
    margin-top: 0;
    font-size:18px;
    }

    .modal-body {
    margin: 20px 0;
    }

    .modal-default-button {
    float: right;
    }

    .modal-footer 
    {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
    opacity: 0;
    }

    .modal-leave-active {
    opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    }

    .delete_btn 
    {
        background:$dangerColor !important;
        
    }

</style>